module.exports = __webpack_public_path__ + "img/商家二维码@2x.47f22b85.png";